let _ = t => t,
  _t;
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import styledWithTheme, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ClampedText = styledWithTheme.div(_t || (_t = _`
  &:hover {
    ${0}
  }

  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: ${0};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  word-break: break-word;
`), ({
  underlineOnHover
}) => underlineOnHover && css(["text-decoration:underline;"]), ({
  lines
}) => lines || 2);
export const ContentTypeBadgeMap = {
  CERTIFICATION: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(CertificationIcon, {
      color: "fill-brand-default",
      size: "300"
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentTypes.CERTIFICATION"
      })
    })]
  }),
  COURSE: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.COURSE"
  }),
  LESSON: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.LESSON"
  }),
  VIDEO: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.VIDEO"
  }),
  ACADEMY_VIDEO: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.ACADEMY_VIDEO"
  }),
  PLAYLIST: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.PLAYLIST"
  }),
  HUBSPOT_PLAYLIST: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.HUBSPOT_PLAYLIST"
  }),
  LIVE_EVENT: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.LIVE_EVENT"
  })
};